
import React, { useState } from 'react';
import { Avatar, List, Modal, Space, Tooltip, Typography } from 'antd';
import { CalendarOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

const { Text, Title } = Typography;

// ===== Styled Components =====
const ItemContainer = styled(List.Item)`
  display: flex;
  justify-content: space-between;
`;

const RowHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const AvatarGroup = styled(Space)`
  margin-left: 26px;
  margin-top: 8px;
`;

const COLOR_LIST = ['#f56a00', '#7265e6', '#ffbf00', '#00a2ae'];

const getInitial = (name) => name?.charAt(0).toUpperCase();

const getColor = (identifier) => {
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = identifier.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLOR_LIST[Math.abs(hash) % COLOR_LIST.length];
};

const UserAvatarList = ({ title, users }) => {
  const [selectedUser, setSelectedUser] = useState(null);

  const handleAvatarClick = (user) => {
    setSelectedUser(user);
  };

  console.log("usersUserAvatarList", users)

  return (
    <>
      <ItemContainer>
        <RowHeader>
          <CalendarOutlined style={{ marginRight: 8 }} />
          <Text strong>{title}</Text>
        </RowHeader>

        <AvatarGroup size={12}>
          {users?.map((entry) => {
            const { member, permission } = entry;
            const hasImage =
              member.profile_image && !member.profile_image.includes('default_profile');
            const color = getColor(member.email);

            return (
              <Tooltip key={member.id} title={member.name}>
                <Avatar

                  src={member.profile_image}
                  style={{
                    backgroundColor: hasImage ? undefined : color, // ✅ uses fallback color
                    cursor: 'pointer',
                  }}
                  onClick={() => handleAvatarClick(entry)}
                />
                  {/* {!hasImage && getInitial(member.name)} 
                </Avatar> */}
              </Tooltip>
            );
          })}
        </AvatarGroup>
      </ItemContainer>

      <Modal
        title="User Details"
        open={!!selectedUser}
        onCancel={() => setSelectedUser(null)}
        footer={null}
      >
        {selectedUser && (
          <Space align="start">
            <Avatar
              size={64}
              src={
                selectedUser.member.profile_image.includes('default_profile')
                  ? undefined
                  : selectedUser.member.profile_image
              }
              style={{
                backgroundColor: selectedUser.member.profile_image.includes('default_profile')
                  ? getColor(selectedUser.member.email)
                  : undefined,
                fontSize: 24,
              }}
            >
              {selectedUser.member.profile_image.includes('default_profile') &&
                getInitial(selectedUser.member.name)}
            </Avatar>
            <div>
              <Title level={5}>{selectedUser.member.name}</Title>
              <Text type="secondary">
                <MailOutlined /> {selectedUser.member.email}
              </Text>
              <br />
              {selectedUser.permission && (
                <Text>
                  <UserOutlined /> Permission: {selectedUser.permission.name}
                </Text>
              )}
            </div>
          </Space>
        )}
      </Modal>
    </>
  );
};

export default UserAvatarList;
